import React, { useState, useReducer } from "react";
import AppButton from "components/FormsUI/AppButton/appButton";
import { Modal } from "react-bootstrap";

const ModalContext = React.createContext({
    openModal: (body, title, config) => new Promise(()=>{}),
    modalDispatch: (action) => {}
});

const modalInitState = {
    size: "md", // sm | md | lg | xl
    title: '',
    body: <div>Modal body</div>,
    submitLabel: "Submit",
    cancelLabel: "Cancel",
    showCancel: true,
    showActions: true,
    key: new Date().getTime(),
    submitFunc: null,
    centered: false

}

const modalReducer = (state, action) => {
  return action;
}

export const ModalContextProvider = (props) => {
  const [show, setShow] = useState(false);
  const [modalProps, setModalProps] = useState(modalInitState);
  const [modalState, dispatch] = useReducer(modalReducer, {type: "none", payload: null})
  

  // body must be element or jsx.element
  const openModal = (body, title = "", config = {}) =>
    new Promise((resolve, reject) => {
      const handleResolve = (data) => {
        setShow(false);
        resolve(data);
      };

      const handleReject = (data) => {
        setShow(false);
        reject(data);
      };

      setModalProps(state => {
        const newState = {
          ...modalInitState,
          ...config,
          title,
          body,
          bodyProps: config?.bodyProps,
          key: new Date().getTime(),
          handleResolve,
          handleReject
        }

        if(newState.body.type && typeof newState.body.type !== 'string'){
          newState.body = React.cloneElement(body, {onReject: handleReject, onResolve: handleResolve, state: modalState});
        }

        return newState;
      }
        );
      setShow(true);
    });

  const modalDispatch = (action) => {
    dispatch(action);
  }


  return (
    <ModalContext.Provider value={{ openModal, modalDispatch }}>
      <Modal
        show={show}
        key={modalProps.key}
        onHide={() => modalProps.handleReject(false)}
        backdrop="static"
        keyboard={false}
        size={modalProps.size}
        centered={modalProps.centered}
        >
        <Modal.Header closeButton>
          <Modal.Title>{modalProps.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {modalProps.body}
        </Modal.Body>
        {modalProps.showActions && 
          <Modal.Footer>
              {modalProps.showCancel && 
                  <div className="col-6 col-md-2 m-0 px-1">
                      <AppButton action={()=>modalProps.handleReject(false)} label={modalProps.cancelLabel} isBlock={true} color="danger"></AppButton>
                  </div>
              }
              <div className="col-6 col-md-2 m-0 px-1">
                  <AppButton action={modalProps.submitFunc ? modalProps.submitFunc : () => modalProps.handleResolve(true)} label={modalProps.submitLabel} isBlock={true}></AppButton>
              </div>
          </Modal.Footer>
        }
      </Modal>
      {props.children}
    </ModalContext.Provider>
  );
};

export default ModalContext;
